'use strict';

/* Copyright 2018 The Mathworks, Inc. */

define([], function () {
  // Do not add items without additional "filtering code"

  // https://github.com/leizongmin/js-xss/blob/master/dist/xss.js#L12
  // + Style
  var whiteListJava = {
    A: ['target', 'href', 'title'],
    ABBR: ['title'],
    ADDRESS: [],
    AREA: ['shape', 'coords', 'href', 'alt'],
    ARTICLE: [],
    ASIDE: [],
    AUDIO: ['autoplay', 'controls', 'loop', 'preload', 'src'],
    B: [],
    BDI: ['dir'],
    BDO: ['dir'],
    BIG: [],
    BLOCKQUOTE: ['cite'],
    BR: [],
    CAPTION: [],
    CENTER: [],
    CITE: [],
    CODE: [],
    COL: ['align', 'valign', 'span', 'width'],
    COLGROUP: ['align', 'valign', 'span', 'width'],
    DD: [],
    DEL: ['datetime'],
    DETAILS: ['open'],
    DIV: [],
    DL: [],
    DT: [],
    EM: [],
    FONT: ['color', 'size', 'face'],
    FOOTER: [],
    H1: [],
    H2: [],
    H3: [],
    H4: [],
    H5: [],
    H6: [],
    HEADER: [],
    HR: [],
    I: [],
    IMG: ['src', 'alt', 'title', 'width', 'height'],
    INS: ['datetime'],
    LI: [],
    MARK: [],
    NAV: [],
    OL: [],
    P: [],
    PRE: [],
    S: [],
    SECTION: [],
    SMALL: [],
    SPAN: [],
    SUB: [],
    SUP: [],
    STRONG: [],
    TABLE: ['width', 'border', 'align', 'valign'],
    TBODY: ['align', 'valign'],
    TD: ['width', 'rowspan', 'colspan', 'align', 'valign'],
    TFOOT: ['align', 'valign'],
    TH: ['width', 'rowspan', 'colspan', 'align', 'valign'],
    THEAD: ['align', 'valign'],
    TR: ['rowspan', 'align', 'valign'],
    TT: [],
    U: [],
    UL: [],
    VIDEO: ['autoplay', 'controls', 'loop', 'preload', 'src', 'height', 'width']
  };

  var protocolAttrsWhiteListJava = {
    href: {
      'http:': true,
      'https:': true,
      'mailto:': true,
      'matlab:': true,
      relative: {
        '#': true,
        '/': true
      }
    },
    src: {
      'http:': true,
      'https:': true,
      'mailto:': true,
      relative: {
        '#': true,
        '/': true
      }
    }
  };

  // Pull out uncommon styles or styles that support:
  // Urls as options
  // Also pull out styles that would generally allow:
  // Clickjacking attacks
  var whiteListStyles = ['backgroundColor', 'borderBottom', 'borderBottomColor', 'borderBottomLeftRadius', 'borderBottomRightRadius', 'borderBottomStyle', 'borderBottomWidth', 'borderLeft', 'borderLeftColor', 'borderLeftStyle', 'borderLeftWidth', 'borderRadius', 'borderRight', 'borderRightColor', 'borderRightStyle', 'borderRightWidth', 'borderSpacing', 'borderStyle', 'borderTop', 'borderTopColor', 'borderTopLeftRadius', 'borderTopRightRadius', 'borderTopStyle', 'borderTopWidth', 'borderWidth', 'color', 'fontFamily', 'fontSize', 'fontStyle', 'fontWeight', 'height', 'lineHeight', 'margin', 'marginBottom', 'marginLeft', 'marginRight', 'marginTop', 'maxHeight', 'maxWidth', 'minHeight', 'minWidth', 'overflow', 'overflowWrap', 'overflowX', 'overflowY', 'padding', 'paddingBottom', 'paddingLeft', 'paddingRight', 'paddingTop', 'textAlign', 'textAnchor', 'textDecoration', 'textIndent', 'textOverflow', 'textShadow', 'textTransform', 'width'];

  var copyAndSanitizeStyles = function copyAndSanitizeStyles(cleanNode, dirtyNode) {
    var wasStyleTagSpecified = dirtyNode.getAttribute('style');
    if (cleanNode.style && wasStyleTagSpecified !== null && wasStyleTagSpecified !== '') {
      for (var i = 0; i < whiteListStyles.length; i += 1) {
        var styleKey = whiteListStyles[i];
        var value = dirtyNode.style[styleKey];
        if (cleanNode.style[styleKey] !== undefined) {
          cleanNode.style[styleKey] = value;
        }
      }
    }
  };

  var buildSanitizer = function buildSanitizer(whiteList, whitelistProtocols, allowStyleTag) {
    return function (htmlToClean) {
      var cleanUrl = function cleanUrl(whitelistProtocols, dirtyUrl) {
        var dirtyTrimUrl = String.prototype.trim.call(dirtyUrl);
        var locateColon = dirtyTrimUrl.indexOf(':');
        if (locateColon < 0) {
          // Check Relative
          if (whitelistProtocols.relative[dirtyTrimUrl.charAt(0)]) {
            return dirtyTrimUrl;
          }
        }
        var protocol = dirtyTrimUrl.substring(0, locateColon);
        if (whitelistProtocols[protocol + ':']) {
          return dirtyTrimUrl;
        }
        return '#';
      };

      var getCleanAttrs = function getCleanAttrs(whitelistAttrs, dirtyElem) {
        var cleanAttrs = [];
        for (var attrIndex = 0; attrIndex < whitelistAttrs.length; attrIndex += 1) {
          var attrToCheck = whitelistAttrs[attrIndex];
          if (dirtyElem.hasAttribute(attrToCheck)) {
            var dirtyValue = dirtyElem.getAttribute(attrToCheck);
            var cleanValue = '';
            if (whitelistProtocols[attrToCheck]) {
              cleanValue = cleanUrl(whitelistProtocols[attrToCheck], dirtyValue);
            } else {
              cleanValue = dirtyValue;
            }
            cleanAttrs.push({
              key: attrToCheck,
              value: cleanValue
            });
          }
        }
        return cleanAttrs;
      };

      var getCleanNode = function getCleanNode(dirtyNode) {
        var cleanNode = void 0;
        if (dirtyNode.nodeType === window.Node.ELEMENT_NODE) {
          var found = whiteList[dirtyNode.tagName];
          if (found) {
            cleanNode = document.createElement(dirtyNode.tagName);
            var whiteListAttr = whiteList[dirtyNode.tagName];
            var cleanAttr = getCleanAttrs(whiteListAttr, dirtyNode);
            cleanAttr.forEach(function (item) {
              cleanNode.setAttribute(item.key, item.value);
            });
            if (allowStyleTag) {
              copyAndSanitizeStyles(cleanNode, dirtyNode);
            }
          } else {
            // We could potentially "Keep Children", "Replace bad node with div", or "Discard children"
            cleanNode = document.createDocumentFragment();
          }
        } else if (dirtyNode.nodeType === window.Node.TEXT_NODE) {
          cleanNode = document.createTextNode(dirtyNode.textContent);
        } else {
          cleanNode = document.createDocumentFragment();
        }
        return cleanNode;
      };

      var sanitizeDom = function sanitizeDom(dirtyRoot) {
        var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

        var cleanNode = document.createDocumentFragment();
        if (level > 150 || !dirtyRoot) {
          // Keep stack a reasonable size
          // (Firefox Limits DOM 200 levels deep)
          // and don't recurse null nodes
          return cleanNode;
        }
        for (var dirtyChild = dirtyRoot.firstChild; dirtyChild; dirtyChild = dirtyChild.nextSibling) {
          var tmpNode = getCleanNode(dirtyChild);
          if (dirtyChild.nodeType === window.Node.ELEMENT_NODE) {
            tmpNode.appendChild(sanitizeDom(dirtyChild, level + 1));
          }
          cleanNode.appendChild(tmpNode);
        }
        return cleanNode;
      };

      /* eslint-disable */
      var domParser = new DOMParser();
      /* eslint-enable */
      var dirtyDom = domParser.parseFromString(htmlToClean, 'text/html');
      var cleanDom = void 0;
      if (dirtyDom.body) {
        cleanDom = sanitizeDom(dirtyDom.body);
      } else {
        cleanDom = document.createDocumentFragment();
      }
      return cleanDom;
    };
  };

  return {
    sanitizeHtmlFromJava: buildSanitizer(whiteListJava, protocolAttrsWhiteListJava, true)
  };
});
//# sourceMappingURL=sanitize.js.map
